import React from 'react'
import Typewriter from "typewriter-effect";
import mainSection from '../../../assets/svg/mainSection.svg'
import MoreArrow from '../../Helper/MoreArrow'
import moreArrow  from "../../../constants/moreArrow"
import './MainContent.css'

const styles = {
    mainWrapper: `grid grid-cols-1 md:grid-cols-2 sm:w-full`,
    bannerLeftContainer: "flex justify-center items-start md:items-center lg:items-start flex-col order-2 md:order-1 pl-2 sm:pl-0 sm:mr-5 md:mr-0 md:pl-12",
    bannerLeftSubContainer: "flex flex-col justify-center items-start sm:items-center",
    textMainContainer: "sm:w-10/12 flex items-center sm:centerContent  mb-5 sm:mb-0",
    pSpan: 'uppercase font-bold tracking-wide text-sm sm:text-md 2xl:text-lg',
    h1Heading: 'text-4xl md:text-3xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold tracking-wide w-10/12 text-[#333333]',
    imgStyle: 'h-full w-full px-2 sm:px-0 sm:h-5/6 sm:w-10/12',
    bannerRightContainer: "centerContent order-1 md:order-2 lg:pr-6"
}

const MainContent = () => {
  return (
    <section className={styles.mainWrapper}>
        <div className={styles.bannerLeftContainer}>
            <div className={styles.bannerLeftSubContainer}>
                <div className={styles.textMainContainer}>
                    <p>
                        <span className={styles.pSpan.concat(' text-primary')}>
                            <Typewriter
                                onInit={(typewriter) => {
                                typewriter
                                    .pauseFor(50)
                                    .typeString('creative mind, <span style="color: #FF4092">creative work</span>')
                                    .start()
                                }}
                            />
                        </span>
                    </p>
                </div>
                <h1 className={styles.h1Heading}>We are a Digital Agency.</h1>
                <div className="sm:w-10/12">
                    <MoreArrow  text={moreArrow.TEXT_TALK} />
                </div>
            </div>
        </div>

        <div className={styles.bannerRightContainer}>
            <img src={mainSection} alt="Main Section" className={styles.imgStyle} />
        </div>
    </section>
  )
}

export default MainContent